import React from 'react'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Alert, Table, Portlet } from '_zari/core'

import EgresoIngresoModoConstant from 'constants/egresoIngresoModo'

import * as CajaEgresoIngresoService from 'services/cajaEgresoIngreso.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Egresos - Ingresos' }]

const ListaEgresosIngresosPage = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)
  const editarDataRef = React.useRef({})

  const [mostrarInsertarActualizarModal, setMostrarInsertarActualizarModal] = React.useState(false)

  const clickNuevo = React.useCallback(e => {
    editarDataRef.current = {}
    setMostrarInsertarActualizarModal(true)
  }, [])

  const clickEditar = React.useCallback(
    id => {
      CajaEgresoIngresoService.obtenerxIdAsEdicion(id)
        .then(({ data }) => {
          editarDataRef.current = data
          setMostrarInsertarActualizarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickAnular = React.useCallback(
    id => {
      CajaEgresoIngresoService.actualizarxIdAsAnular(id)
        .then(() => {
          __zariContext.snack('success', 'Registro anulado')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      {__adminContext.estadoTurno ? (
        <>
          <Portlet>
            <Portlet.Header
              title='Egresos - Ingresos'
              breadcrumbs={portletBreadcrumbs}
              buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
            />
            <Portlet.Body>
              <Table.ServerSide
                ref={tablaRef}
                url='/caja-movimientos'
                headRows={[{ label: 'TIPO' }, { label: 'GLOSA' }, { label: 'MONTO' }, { label: '' }]}
                rowTemplate={row => (
                  <Table.Row hover key={row._id}>
                    <Table.Cell>{row.tipo ? EgresoIngresoModoConstant.__dictionary[row.tipo].nombre : '--'}</Table.Cell>
                    <Table.Cell>{row.glosa}</Table.Cell>
                    <Table.Cell>{row.monto}</Table.Cell>
                    <Table.Cell>
                      <Table.Dropdown>
                        {({ handleClose }) => [
                          <Table.Dropdown.Item
                            key='editar'
                            handleClose={handleClose}
                            onClick={e => clickEditar(row._id)}
                          >
                            Editar
                          </Table.Dropdown.Item>,
                          <Table.Dropdown.Item
                            key='anular'
                            handleClose={handleClose}
                            onClick={e => clickAnular(row._id)}
                          >
                            Anular
                          </Table.Dropdown.Item>
                        ]}
                      </Table.Dropdown>
                    </Table.Cell>
                  </Table.Row>
                )}
              />
            </Portlet.Body>
          </Portlet>
          {mostrarInsertarActualizarModal && (
            <Modals.InsertarActualizarModal
              handleClose={e => setMostrarInsertarActualizarModal(false)}
              show={mostrarInsertarActualizarModal}
              reloadTable={tablaRef.current.reload}
              editarData={editarDataRef.current}
            />
          )}
        </>
      ) : (
        <Alert color='danger'>Esta función requiere aperturar turno.</Alert>
      )}
    </>
  )
}

export default ListaEgresosIngresosPage
